import { Component, Input, OnDestroy } from '@angular/core';
import { BIChildGridComponent } from '../BI-ChildGrid/bi-childGrid.component';
import { IGrid } from 'bi-interfaces/lib/interfaces/IGrid';
import { FormGroup } from '@angular/forms';
import { CellClickEvent, CellCloseEvent } from '@progress/kendo-angular-grid';
enum StatusAction {
  ADD = "Add",
  UPDATE = "Update",
  NOP = "NOP",
  Delete = "Delete"
}
@Component({
  selector: 'lib-bi-master-grid-details-children',
  templateUrl: './bi-master-grid-details-children.component.html',
  styleUrls: ['./bi-master-grid-details-children.component.scss']
})
export class BiMasterGridDetailsChildrenComponent extends BIChildGridComponent implements IGrid, OnDestroy {
  @Input() forms: FormGroup[] = []
  @Input() colorsLines: any;
  override InitReactiveFormData() {
    this.RowSubscription?.unsubscribe();
    this.formGroups = [];
    this.data['data']?.forEach((response: any, index: any) => {
      response[this.RowIdentifier] = this.GetNewRowID();
      let formGroup = this.formBuilder.group(this.form);
      formGroup.patchValue({ ...response });
      this.setDefaultDate(formGroup);
      Object.keys(formGroup.controls).forEach((name: any) => {
        if (name.includes(".")) formGroup.controls[name].patchValue(this.getValuePipe.get(response, name));
      })
      this.formGroups.push(formGroup);
    });
  }

  public override GetGridData() {
    this.GridData = this.DataService;
    this.GridDataSubscription = this.GridData.subscribe((res: any) => {
      this.totalDataLength = res.total;
      this.data = res;
      if (this.Mygrid && this.data && this.data.total > 0) {
        this.InitReactiveFormData();
        //  if (!this.rowIndex) {
        this.resetRowIndex = 0;
        // }
        if (this.formGroups.length) {
          this.CurrentSelectRow = this.formGroups[0];
          if (this.formGroups[0])
            this.OverviewDataBindingSubscribtion(this.formGroups[0].controls[this.RowIdentifier].value);
          this.RowChange.emit();
        }
      }
      else {
        // this.CurrentSelectRow.reset();
        this.formGroups = [];
      }
      this.OnLoadData.emit(null);
    });
  }


  override ngOnDestroy(): void {
    this.GridDataSubscription?.unsubscribe();
    this.RowSubscription?.unsubscribe();
    this.StopDeleteSubscription?.unsubscribe();
    this.StopAddSubscription?.unsubscribe();
    this.StopSaveSubscription?.unsubscribe();
    this.DeleteSubscription?.unsubscribe();
    this.AddSubscription?.unsubscribe();
    this.EditSaveSubscription?.unsubscribe();
    this.setPreventCloseRowSubscription?.unsubscribe();
    if (this.changeSet.changesetArr.findIndex((res: any) => res.Grid?.DomID == this.DomID) >= 0)
      this.changeSet.changesetArr.splice(this.changeSet.changesetArr.findIndex((res: any) => res.Grid?.DomID == this.DomID), 1)
  }

  override EnableDisable_columns(colmnNames: string[], IsEditable: boolean): void {
    if (IsEditable) {
      colmnNames.forEach(columnName => {
        this.CurrentSelectRow?.controls[columnName]?.enable({ emitEvent: false });
      });
    } else {
      colmnNames.forEach(columnName => {
        this.CurrentSelectRow?.controls[columnName]?.disable({ emitEvent: false });
      });
    }
    this.Columns = this.Columns.filter(res => {
      if (colmnNames.includes(res.Name)) {
        res.IsEditable = IsEditable;
      }
      return res;
    })
  }
}
